import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { PeopleItem } from '../../shared';

class OurTeam extends React.Component<any, any> {

    constructor(props, context) {
        super(props, context);
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        if (!this.props.aboutPeople || this.props.isLoading) {
            return (<div></div>);
        }

        let items = this.props.aboutPeople.filter(f => f.categoryId == 1).map((item, index) => {
             return  <PeopleItem style={{paddingBottom: "20px"}} key={"people1Item" + index} {...item}></PeopleItem>; 
            });

        return (
        
        <div id="SectionContainer">
            <section className="content page-content" style={{ backgroundColor: "#f5f5f5"}}> 

                <div className="container-spacing container pt-50  mb-4">
                        <h1>Our Team</h1>
                    </div>
                <div className="container" style={{paddingBottom: "150px"}}>
                    {items}
                </div>
            </section>
        </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        aboutPeople: state.siteData.siteData.aboutPeople,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        { },
        dispatch
    );
};


const OurTeamContainer = connect(mapStateToProps, mapDispatchToProps)(
    OurTeam
);

export default OurTeamContainer;


// WEBPACK FOOTER //
// ./src/components/People/OurTeam.tsx